import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { PopUp } from "../../components/PopUp/PopUp.js";
import LoadingOverlay from "react-loading-overlay-ts";
import { filterBy } from "@progress/kendo-data-query";
import { RiDownloadCloud2Line } from "react-icons/ri";
import { verifyUploadAPI } from "../../../api/verifyAPI/verifyUploadAPI.js";

function AuditRequestGridContainer({ dataGrid }) {
  const initialSort = [
    {
      field: "insertUtcDateTime",
      dir: "desc",
    },
  ];

  const voidRecord = [];
  const [filter, setFilter] = React.useState();
  const [values, setValues] = React.useState(voidRecord);
  //setData(dataGrid);
  const [isActive, setActive] = useState(false);
  const [sort, setSort] = useState(initialSort);
  const [show, setShow] = useState(false);

  const showModal = () => {
    setShow(true);
  };

  const hideModal = () => {
    setShow(false);
  };

  useEffect(() => {
    if (dataGrid !== undefined) {
      let newData;
      if (filter && filter.filters.length > 0) {
        newData = filterBy(dataGrid, filter).map((item, idx) => ({
          ...item,
        }));
      } else {
        newData = dataGrid.map((item, idx) => ({
          ...item,
        }));
      }
      setValues(newData);
    }
  }, [dataGrid, filter]);

  const initialDataState = {
    skip: 0,
    take: 12,
  };
  const handleDownload = (downlaodId, type) => {
    setActive(true);
    verifyUploadAPI
      .exportExcel(downlaodId, type)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        let fileName = `${type}List.xlsx`;

        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        setShow({
          status: true,
          message:
            "Si è verificato un errore durante il tentativo di importare il file.",
        });
      })
      .finally(() => {
        setActive(false);
      });
  };
  const [page, setPage] = React.useState(initialDataState);

  const pageChange = (event) => {
    setPage(event.page);
  };
  const filterChange = (event) => {
    if (event.filter && event.filter.filters.length > 0) {
      setFilter(event.filter);
    } else {
      setFilter(null);
    }
  };

  return (
    <>
      <LoadingOverlay active={isActive} spinner text="Loading ...">
        <PopUp show={show} handleClose={hideModal}>
          <div
            className="row"
            style={{
              height: "30px",
              marginLeft: "0px",
              marginRight: "0px",
              backgroundColor: "#FDA443",
              borderRadius: "10px 10px 0px 0px",
            }}
          >
            {" "}
          </div>
          <p></p>
          <h2 className="row justify-content-md-center">
            {" "}
            Attenzione: Nessun file Excel caricato!
          </h2>
        </PopUp>
        <Grid
          style={{
            height: "650px",
          }}
          filterable={true}
          filter={filter}
          onFilterChange={filterChange}
          data={orderBy(values, sort).slice(page.skip, page.take + page.skip)}
          skip={page.skip}
          take={page.take}
          total={values.length}
          pageable={true}
          onPageChange={pageChange}
          resizable={true}
          sortable={true}
          sort={sort}
          onSortChange={(e) => {
            setSort(e.sort);
          }}
        >
          <Column field="actionType" title="Tipo Evento" width="auto" />
          <Column
            field="insertUtcDateTime"
            title="Data"
            width="auto"
            cell={(props) => {
              const date = new Date(props.dataItem["insertUtcDateTime"]);
              const formattedDate = date.toLocaleString("it-IT", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
              });
              return <td>{formattedDate}</td>;
            }}
          />
          <Column field="utente" title="Utente" width="auto" />
          <Column field="result" title="Risultati" width="auto" />
          <Column
            field="link"
            title="Link"
            width="auto"
            cell={(props) => {
              const actionType = props.dataItem["actionType"];
              const linkType = props.dataItem["linkType"];
              const link = props.dataItem["link"];
              return actionType === "FILE" &&
                (linkType === "PHONE" || linkType === "EMAIL") ? (
                <td>
                  <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command"
                    style={{
                      backgroundColor: "#007bff",
                      color: "#fff",
                      border: "1px solid #007bff",
                    }}
                    onClick={() => handleDownload(link, linkType)}
                  >
                    <RiDownloadCloud2Line
                      size={20}
                      style={{ marginRight: "5px" }}
                    />
                  </button>
                </td>
              ) : (
                <td>{props.dataItem.result}</td>
              );
            }}
          />
          <Column field="linkType" title="Link Type" width="auto" />
        </Grid>
      </LoadingOverlay>
    </>
  );
}

export const AuditRequestGrid = connect(null, null)(AuditRequestGridContainer);
